import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Plus } from "lucide-react";

interface GoogleAnalyticsAddButtonProps {
  onSelectExisting: () => void;
  onConnectNew: () => Promise<void> | void;
  hasConnectedAccounts: boolean;
  isConnecting?: boolean;
  className?: string;
}

export function GoogleAnalyticsAddButton({
  onSelectExisting,
  onConnectNew,
  hasConnectedAccounts,
  isConnecting = false,
  className = "",
}: GoogleAnalyticsAddButtonProps) {
  // No connected accounts: go directly to OAuth
  if (!hasConnectedAccounts) {
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={() => onConnectNew()}
        disabled={isConnecting}
        className={className}
      >
        {isConnecting ? (
          "Connecting…"
        ) : (
          <>
            <Plus className="h-4 w-4 mr-2" />
            Connect
          </>
        )}
      </Button>
    );
  }

  // Has connected accounts: show dropdown with options
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          disabled={isConnecting}
          className={className}
        >
          {isConnecting ? (
            "Connecting…"
          ) : (
            <>
              <Plus className="h-4 w-4 mr-2" />
              Connect
            </>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onSelectExisting}>
          Select existing account
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onConnectNew()}>
          Connect new account
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
